import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { ContactInputDTO, ContactOutputDTO } from 'src/services/reservation/contact/contactDTO'
class ContactServices {
  async updateById(id: number, body: ContactInputDTO): Promise<ContactOutputDTO> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/contact/${id}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const contactServices = new ContactServices()
